import React, { FunctionComponent } from 'react';
import { ComplexAction, EmptyState } from '@shopify/polaris';
import { useRouter } from 'next/router';

export type EmptyStateProps = {
  action?: ComplexAction;
  actionContent?: string;
  onClickRoute?: string;
  content: string | React.ReactNode;
};

const EmptyStateComponent: FunctionComponent<EmptyStateProps> = (props) => {
  const { action, actionContent, content, onClickRoute } = props;

  const router = useRouter();

  const handleRouteChange = (route: string) => {
    router.push(route);
  };

  return (
    <EmptyState
      action={
        action ??
        (actionContent
          ? {
              content: actionContent,
              onAction: () => onClickRoute && handleRouteChange(onClickRoute),
            }
          : undefined)
      }
      image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
    >
      <p>{content}</p>
    </EmptyState>
  );
};

export default EmptyStateComponent;
